export default "__VITE_ASSET__e6d6d665__"